import React, { useState } from "react";
import { useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import SpinnerNew from "~/components/SpinnerNew";
import { Button, Modal, Accordion, Card, Badge } from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import Alert from "@mui/material/Alert";

const ModalProfiles = ({ show, onClose, isMobile, profilesRowSelected, t }) => {
  const { isLoadingProfilesByEncargo } = useSelector(
    (state) => state.cvManagementReducer
  );

  // Estado para controlar o accordion aberto
  const [activeKey, setActiveKey] = useState("");

  // Colunas da tabela
  const columns = [
    { dataField: "nome", text: "Nome", style: { alignContent: "center" } },
    {
      dataField: "dominio",
      text: "Domínio",
      style: { alignContent: "center" },
    },
    {
      dataField: "anosExperiencia",
      text: "Anos de Experiência",
      style: { alignContent: "center" },
    },
    {
      dataField: "grauAcademico",
      text: "Grau Académico",
      style: { alignContent: "center" },
    },
    {
      dataField: "linguas",
      text: "Línguas",
      style: { alignContent: "center" },
    },
    {
      dataField: "matchLevel",
      text: "Match Level",
      headerStyle: { width: "55px" },
      style: { alignContent: "center" },
    },
  ];

  function formatDateToDDMMYYYY(dateStr) {
    if (!dateStr) return "-";
    // yyyy-MM-ddTHH:mm:ss... → dd/MM/yyyy
    const match = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, y, m, d] = match;
      return `${d}/${m}/${y}`;
    }
    // yyyy-MM-dd → dd/MM/yyyy
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    }
    // MM/dd/yyyy → dd/MM/yyyy
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
      const [a, b, c] = dateStr.split("/");
      if (parseInt(a, 10) > 12) return dateStr;
      if (parseInt(b, 10) > 12) return `${b}/${a}/${c}`;
      return `${b}/${a}/${c}`;
    }
    return dateStr;
  }

  const getEstadoLabel = (estado) => {
    let stateText = "";
    let variant = "secondary"; // cinza por padrão
    switch (estado) {
      case "OPEN":
        stateText = "Aberto";
        variant = "secondary"; // cinza
        break;
      case "ANALYSIS":
        stateText = "Em Análise";
        variant = "warning"; // laranja
        break;
      case "PENDING":
        stateText = "Pendente";
        variant = "warning"; // laranja
        break;
      case "SUBMITTED":
        stateText = "Submetido";
        variant = "success"; // verde
        break;
      case "EXPIRED":
        stateText = "Fim de Prazo";
        variant = "danger"; // vermelho
        break;
      case "FAILED":
        stateText = "Falhado";
        variant = "danger"; // vermelho
        break;
      default:
        stateText = "";
        variant = "";
    }

    return (
      <Badge pill variant={variant}>
        {stateText}
      </Badge>
    );
  };

  const toggleAccordion = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  // Junta todos os profiles de todos os perfisProfissionais e anexa info do perfil de origem
  const allProfiles = (profilesRowSelected?.perfisProfissionais || []).flatMap(
    (perfil) =>
      (perfil.profiles || []).map((profile) => ({
        ...profile,
        perfilOrigem: perfil.formacaoNecessaria || perfil.nome || perfil.id,
      }))
  );

  // Ordena por matchLevel decrescente e busca os 5 melhores
  const topProfiles = allProfiles
    .filter((p) => typeof p.matchLevel === "number")
    .sort((a, b) => b.matchLevel - a.matchLevel)
    .slice(0, 5);

  return (
    <>
      <SpinnerNew open={isLoadingProfilesByEncargo} />
      <Modal
        show={show}
        onHide={onClose}
        dialogClassName="custom-modal modal-80w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Match de Perfis</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert severity="warning">Dados dummy, ecrã em desenvolvimento</Alert>
          <div style={{ padding: "20px" }}>
            {/* Cabeçalho com entidade, dataLimite e estado */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
              }}
            >
              <div>
                <strong>Entidade:</strong> {profilesRowSelected?.entidade}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-end",
                  gap: "2rem",
                }}
              >
                <div>
                  <strong>Data Limite:</strong>{" "}
                  {formatDateToDDMMYYYY(profilesRowSelected?.dataLimite)}
                  <br />
                </div>
                <div>
                  <strong>Estado:</strong>{" "}
                  {getEstadoLabel(profilesRowSelected?.estado)}
                </div>
              </div>
            </div>
            {/* Nome */}
            <div style={{ marginBottom: "2rem", marginTop: "2rem" }}>
              <strong>Nome:</strong> {profilesRowSelected?.nome}
            </div>
            <div
              style={{
                marginBottom: 8,
              }}
            >
              <strong>Perfis:</strong>
            </div>
            {/* Accordion customizado */}
            <Accordion activeKey={activeKey}>
              {profilesRowSelected?.perfisProfissionais?.map(
                (perfil, index) => (
                  <Card key={perfil.id}>
                    <Accordion.Toggle
                      as={Card.Header}
                      eventKey={index.toString()}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                      onClick={() => toggleAccordion(index.toString())}
                    >
                      <span style={{ fontWeight: 500 }}>
                        {perfil.formacaoNecessaria}
                      </span>
                      {activeKey === index.toString() ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={index.toString()}>
                      <Card.Body>
                        <div
                          className="custom-table withoutOverflow"
                          style={{ padding: "1rem" }}
                        >
                          <ToolkitProvider
                            keyField="id"
                            data={[...(perfil.profiles || [])].sort(
                              (a, b) =>
                                (b.matchLevel || 0) - (a.matchLevel || 0)
                            )}
                            columns={columns}
                            search={{ searchFormatted: true }}
                          >
                            {(props) => (
                              <div>
                                <BootstrapTable
                                  {...props.baseProps}
                                  id={`document-table-${perfil.id}`}
                                  responsive
                                  bootstrap4
                                  hover
                                  striped
                                />
                              </div>
                            )}
                          </ToolkitProvider>
                        </div>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                )
              )}
            </Accordion>

            {/* Top 5 Perfis com melhor matchLevel */}
            {topProfiles.length > 0 && (
              <>
                <div style={{ marginBottom: "2rem", marginTop: "2rem" }}>
                  <strong>Top 5 Perfis com Melhor Match:</strong>
                </div>{" "}
                <Card style={{ background: "#f8f9fa" }}>
                  <Card.Body>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                        padding: "1rem",
                      }}
                    >
                      {topProfiles.map((profile, idx) => (
                        <div
                          key={profile.id || idx}
                          style={{
                            padding: "0.5rem 0",
                            borderBottom:
                              idx < topProfiles.length - 1
                                ? "1px solid #e0e0e0"
                                : "none",
                          }}
                        >
                          {/* Primeira linha: nome, domínio, matchLevel */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              flexWrap: "wrap",
                              gap: "1rem",
                            }}
                          >
                            <span>
                              <strong>Nome:</strong> {profile.nome}
                            </span>
                            <span>
                              <strong>Domínio:</strong> {profile.dominio}
                            </span>
                            <span>
                              <strong>Match Level:</strong> {profile.matchLevel}
                            </span>
                          </div>
                          {/* Segunda linha: perfil de origem */}
                          <div
                            style={{
                              marginTop: 4,
                              color: "#888",
                              fontStyle: "italic",
                            }}
                          >
                            <strong>Perfil de origem:</strong>{" "}
                            {profile.perfilOrigem}
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            id="button_cvmanagement_cadernosEncargos_modalProfiles_close"
            variant="danger"
            style={{ minHeight: "44px" }}
            onClick={onClose}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withNamespaces()(ModalProfiles);
